import { toast } from 'react-toastify';

let activeToasts = new Set();

const showUniqueToast = (type, message) => {
  // Prevent duplicate toasts with same message
  if (activeToasts.has(message)) {
    return;
  }

  activeToasts.add(message);

  const toastOptions = {
    containerId: "main-toast",
    onClose: () => {
      activeToasts.delete(message);
    },
    style: {
      background: '#ffffff',
      color: '#333333',
      border: '2px solid #e1e5e9',
      borderRadius: '12px',
      fontWeight: '600',
      fontSize: '14px'
    }
  };

  switch (type) {
    case 'success':
      return toast.success(message, {
        ...toastOptions,
        style: {
          ...toastOptions.style,
          borderLeft: '4px solid #1A8063'
        }
      });
    case 'error':
      return toast.error(message, {
        ...toastOptions,
        style: {
          ...toastOptions.style,
          borderLeft: '4px solid #dc3545'
        }
      });
    case 'warning':
      return toast.warning(message, {
        ...toastOptions,
        style: {
          ...toastOptions.style,
          borderLeft: '4px solid #ffc107'
        }
      });
    case 'info':
      return toast.info(message, {
        ...toastOptions,
        style: {
          ...toastOptions.style,
          borderLeft: '4px solid #0d6efd'
        }
      });
    default:
      return toast(message, toastOptions);
  }
};

export const customToast = {
  success: (message) => showUniqueToast('success', message),
  error: (message) => showUniqueToast('error', message),
  warning: (message) => showUniqueToast('warning', message),
  info: (message) => showUniqueToast('info', message),
  dismiss: () => toast.dismiss(),
  dismissAll: () => {
    toast.dismiss();
    activeToasts.clear();
  }
};